import { Autocomplete, TextField } from '@mui/material';
import { Control, Controller, UseFormGetValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Enum } from '~/data/enums';
import { useFilterActiveEnumsByFormSelections } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/data/useFilterActiveEnumsByFormSelections';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';

type PropsType = {
  control: Control<Form>;
  getValues: UseFormGetValues<Form>;
  employmentTypeOptions: Enum[];
  index: number;
};

export const EmploymentTypeComponent = (props: PropsType) => {
  const { control, index, getValues, employmentTypeOptions } = props;

  const { t } = useTranslation();
  const requiredText = t('fieldIsRequired');

  const { filterActiveEnumsByFormSelections } =
    useFilterActiveEnumsByFormSelections({
      control,
      index,
      getValues,
    });

  const filteredOptions = filterActiveEnumsByFormSelections(
    employmentTypeOptions,
  );

  return (
    <Controller
      control={control}
      name={`schedule.${index}.employment.fEmplType`}
      rules={{
        required: requiredText,
      }}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <Autocomplete
            options={filteredOptions}
            getOptionLabel={(o) => o.name}
            isOptionEqualToValue={(o, v) => o.code === v.code}
            onChange={(_event, value) => {
              onChange(value?.code || '');
            }}
            value={filteredOptions.find((o) => o.code === value)}
            disableClearable={true}
            size={'small'}
            data-testid="employment-type-autocomplete"
            renderInput={(params) => (
              <TextField
                {...params}
                label={t('laEmploymentType')}
                required={true}
                error={!!error}
                helperText={error?.message}
                data-testid="employment-type-input"
                slotProps={{ inputLabel: { shrink: true } }}
              />
            )}
            fullWidth={true}
          />
        );
      }}
    />
  );
};
